import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Action from '@components/Action'
import Radio from '@components/Radio'
import Button from '@components/Button'
import Download from '@components/Icon/Download'

function ExpertPaymentDetailsActions (props) {
  return (
    <div className='actions-wrapper'>
      <ul className='actions right-list'>
        <li className='action'>
          <Action
            onClick={() => {
              props.expertPaymentsStore.expertPaymentExport(props)
            }}
          >
            <Download />
            <span>Export</span>
          </Action>
        </li>
      </ul>
      <PaymentStatusActions expertPaymentsStore={props.expertPaymentsStore} />
    </div>
  )
}

ExpertPaymentDetailsActions.propTypes = {
  expertPaymentsStore: PropTypes.object.isRequired,
  queueProcessorStore: PropTypes.object
}

const PaymentStatusActions = observer(({ expertPaymentsStore }) => {
  const {
    selectedPayments,
    paymentStatusTransitions,
    batchUpdatePaymentStatus,
    staticData
  } = expertPaymentsStore

  if (!selectedPayments.length || !paymentStatusTransitions.length) return null
  return (
    <div className='payment-status-actions'>
      <label>Apply payment status:</label>
      <ul>
        {paymentStatusTransitions.map(status => {
          return (
            <li
              key={status}
              onClick={() => {
                expertPaymentsStore.selectedStatus = status
              }}
            >
              <Radio checked={expertPaymentsStore.selectedStatus === status} />
              <label>{staticData.names.paymentStatuses[status]}</label>
            </li>
          )
        })}
      </ul>
      <Button
        primary
        disabled={!expertPaymentsStore.selectedStatus}
        onClick={batchUpdatePaymentStatus}
      >
        Apply
      </Button>
    </div>
  )
})

export default inject('queueProcessorStore')(
  observer(ExpertPaymentDetailsActions)
)
